import type { IIndustryOption, ITimezoneOption } from '@/@types/businessSettings';

export const INDUSTRIES: IIndustryOption[] = [
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'cleaning', label: 'Cleaning Services' },
  { value: 'hvac', label: 'HVAC' },
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'landscaping', label: 'Landscaping' },
  { value: 'construction', label: 'Construction' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'legal', label: 'Legal Services' },
  { value: 'financial', label: 'Financial Services' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'marketing', label: 'Marketing & Advertising' },
  { value: 'technology', label: 'Technology' },
  { value: 'retail', label: 'Retail' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'other', label: 'Other' },
];

export const TIMEZONE_OPTIONS: ITimezoneOption[] = [
  { value: 'Europe/Nicosia', label: 'Cyprus (Europe/Nicosia)' },
  { value: 'Europe/Athens', label: 'Greece (Europe/Athens)' },
  { value: 'Europe/London', label: 'UK (Europe/London)' },
  { value: 'Europe/Berlin', label: 'Germany (Europe/Berlin)' },
  { value: 'Europe/Moscow', label: 'Russia (Europe/Moscow)' },
  { value: 'Asia/Dubai', label: 'UAE (Asia/Dubai)' },
  { value: 'Asia/Jerusalem', label: 'Israel (Asia/Jerusalem)' },
  { value: 'America/New_York', label: 'US East (America/New_York)' },
  { value: 'America/Los_Angeles', label: 'US West (America/Los_Angeles)' },
  { value: 'UTC', label: 'UTC' },
];
